import { useAuthSelector } from 'app/data/auth';
import { sdk } from 'app/sdk';
import { AxiosError } from 'axios';
import { useMutation } from 'react-query';

export const useDeleteDirectory = () => {
  const authState = useAuthSelector();
  return useMutation<any, AxiosError, string, unknown>((directoryId: string) =>
    sdk.directory.mutate.delete(directoryId, authState?.auth_token),
  );
};
